/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneNoInfinityTeaserBoxTitle from 'base/components/standalone/NoInfinityTeaserBoxTitle';

export const DynamicStandaloneNoInfinityTeaserBoxTitle = StandaloneNoInfinityTeaserBoxTitle;
export type DynamicStandaloneNoInfinityTeaserBoxTitleProps = PropsFromComponent<typeof StandaloneNoInfinityTeaserBoxTitle>;

export const DynamicStandaloneNoInfinityTeaserBoxTitleWith = (extras: DynamicStandaloneExtras): typeof StandaloneNoInfinityTeaserBoxTitle => {
    return function DynamicStandaloneNoInfinityTeaserBoxTitle(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'NoInfinityTeaserBoxTitle');
        return <StandaloneNoInfinityTeaserBoxTitle {...mergeProps({ options: { theme } }, props)} />;
    }
}